import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
	requestAnimationFrame(fn) {
		return window.requestAnimationFrame(fn);
	}

	setTimeout(handler: (...args: any[]) => void, timeout: number): number {
		return window.setTimeout(handler, timeout);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/ng-select/window.service.ts